import { ProfilerAction } from './types'

export enum StartupProfilerEventType {
  EXECUTE_JS_FILES = 'execute-js-files',
  MOUNT_APP = 'mount-app',
  MOUNT_CHAT_LIST = 'mount-chat-list',
  CONNECT_APP = 'connect-app',
  SYNC_APP = 'sync-app',
}

const startupProfilerData: Partial<Record<StartupProfilerEventType, number>> =
  {}

export const sendStartupProfilerEvent = (
  type: StartupProfilerEventType,
  isLastEvent = false,
) => {
  if (!window.appStartTime) return

  startupProfilerData[type] = Math.round(
    performance.now() - window.appStartTime,
  )

  if (isLastEvent) {
    analite(ProfilerAction.STARTUP, {
      durations: startupProfilerData,
    })

    window.appStartTime = undefined
  }
}
